import React from 'react';
import classNames from 'classnames';
const isServer = typeof window === 'undefined';

const getCurrentRoute = () => {
  if (isServer) return null;
  return window.location.pathname.split('?')[0];
};

export default class MobileNavbar extends React.Component {
  getItems() {
    const { currentUser } = this.props;
    return [
      { name: 'newsfeed', links: ['', 'recently', 'followed'], icon: 'icon-home-clear' },
      { name: 'communities', links: ['mycommunities'], icon: 'icon-communities' },
      { name: 'messages', links: ['messages'], icon: 'icon-messages' },
      { name: 'notifications', links: ['notifications'], icon: 'icon-bell-2' },
      { name: 'more', links: ['more-list'], imageUrl: currentUser.avatarImageUrl },
    ];
  }

  renderNavItem(item) {
    const currentRoute = getCurrentRoute();
    const counter = item.links.includes('notifications') ? this.props.unreadNotifications
      : item.links.includes('messages') ? this.props.unreadMessages
      : 0;
    const className = {
      'mobile-navbar__item': true,
      'mobile-navbar__item--active': item.links.includes(currentRoute),
    };
    const notifClassName = 'mobile-navbar__item-notification';
    const notifClasses = `${notifClassName} ${notifClassName}__${item.name}`;

    return <a href={`/${item.links[0]}`} className={classNames(className)} key={item.links[0]} >
      {item.icon && <div className="mobile-navbar__icon">
        {item.icon && <span className={`icon ${item.icon}`}/>}
      </div>}
      {item.imageUrl && <div className="mobile-navbar__image">
        <img src={item.imageUrl} />
      </div>}
      {counter > 0 && <div className={notifClasses}>{counter}</div>}
    </a>;
  }

  render() {
    const items = this.getItems();
    return <div className="mobile-navbar">
      {items.map(i => this.renderNavItem(i))}
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/siteBar/mobileNavBar.js